var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "booking-add-ons__quantity-selector",
      class: [{ "--no-price": _vm.priceAndTypeLabel === "" }],
    },
    [
      _c(
        "div",
        { staticClass: "booking-add-ons__quantity-selector-label" },
        [
          _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
          _vm.showTooltip && _vm.tooltipMessage !== ""
            ? _c(
                "v-dropdown",
                {
                  staticClass: "tooltip tooltip-variant--add-on-footer",
                  attrs: { distance: 25, skidding: 0, placement: "top" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "popper",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "tooltip-variant--add-on-footer tooltip-content",
                              },
                              [
                                _c("div", { staticClass: "tooltip-header" }, [
                                  _c("button", {
                                    directives: [
                                      {
                                        name: "close-popper",
                                        rawName: "v-close-popper",
                                      },
                                    ],
                                    staticClass: "icon-close",
                                    attrs: {
                                      "aria-label": _vm.tc("booking.close"),
                                      tabindex: "0",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "tooltip-body" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.tooltipMessage) +
                                      "\n          "
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1737813502
                  ),
                },
                [
                  _c("button", {
                    staticClass: "tooltip-icon icon-info",
                    attrs: { "aria-label": _vm.tooltipMessage },
                  }),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.priceAndTypeLabel
        ? _c(
            "div",
            { staticClass: "booking-add-ons__quantity-selector-price" },
            [_vm._v("\n    " + _vm._s(_vm.priceAndTypeLabel) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "booking-add-ons__quantity-selector-ctas" }, [
        _c(
          "button",
          {
            class: ["minus-cta", { "--disabled": _vm.disableMinusCta }],
            attrs: {
              "aria-disabled": _vm.disableMinusCta,
              "aria-label": _vm.decreaseQuantityLabel,
            },
            on: { click: _vm.decreaseQuantity },
          },
          [_c("div", { staticClass: "icon-minus" })]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "quantity", attrs: { role: "status" } }, [
          _c("span", { staticClass: "sr-only" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" " + _vm._s(_vm.value)),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            class: ["plus-cta", { "--disabled": _vm.disablePlusCta }],
            attrs: {
              "aria-disabled": _vm.disablePlusCta,
              "aria-label": _vm.increaseQuantityLabel,
            },
            on: { click: _vm.increaseQuantity },
          },
          [_c("div", { staticClass: "icon-add" })]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }